import { getCardList, addCard, deleteCard } from 'Api/creditCardApi'
import { parseCard } from 'Parsers/creditCardParser'
import { formatCard } from 'Formatters/creditCardFormatter'

const state = {
  requesting: {
    list: false,
    add: false,
    delete: false,
  },

  cardList: [],
  selected: null,
}

const mutations = {
  request_start(state, type) {
    state.requesting[type] = true
  },

  request_success(state, type) {
    state.requesting[type] = false
  },

  request_failure(state, type) {
    state.requesting[type] = false
  },

  set_card_list(state, cardList) {
    state.cardList = cardList
  },

  set_selected_card(state, selected) {
    state.selected = selected
  },
}

const actions = {
  async getCards({ commit }) {
    commit('request_start', 'list')

    try {
      const { data } = await getCardList()

      const cardList = data.map(parseCard)
      commit('set_card_list', cardList)

      commit('request_success', 'list')

      return data
    } catch (err) {
      commit('request_failure', 'list')

      throw err
    }
  },

  async addCard({ commit }, cardModel) {
    commit('request_start', 'add')

    try {
      const newCard = formatCard(cardModel)
      const result = await addCard(newCard)

      commit('request_success', 'add')

      return result
    } catch (err) {
      commit('request_failure', 'add')

      throw err
    }
  },

  async deleteCard({ commit }, cardId) {
    commit('request_start', 'delete')

    try {
      const result = await deleteCard(cardId)
      commit('request_success', 'delete')

      return result
    } catch (err) {
      commit('request_failure', 'delete')

      throw err
    }
  },

  selectCard({ commit }, cardId) {
    commit('set_selected_card', cardId)
  },
}

export default {
  namespaced: true,

  state,
  actions,
  mutations
}
